import { render } from "./TopicToBeCovered.vue?vue&type=template&id=3e354c04"
import script from "./TopicToBeCovered.vue?vue&type=script&lang=js"
export * from "./TopicToBeCovered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__